var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.795,
    height: 13.278,
    viewBox: "0 0 17.795 13.278",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "download",
    d: "M14.443,8.232a5.555,5.555,0,0,0-11.091,0,4.054,4.054,0,0,0,.726,8.047h9.639a4.054,4.054,0,0,0,.726-8.047ZM8.9,13.328,5.932,10.377H8.156V7.426H9.639v2.951h2.224Z",
    transform: "translate(0 -3)",
    fill: "#597adb"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.b6783fca63b4e09d5e7644e80edf94a6.svg";
export { ForwardRef as ReactComponent };